export default "__VITE_ASSET__BwC_uezg__"